import React, { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { KeyNumbers } from './components/KeyNumbers';
import { Problems } from './components/Problems';
import { BrandReveal } from './components/BrandReveal';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { PlaybookSpotlight } from './components/PlaybookSpotlight';
import { WhoItsFor } from './components/WhoItsFor';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ink" data-id="element-0" data-mp="28suv0pbgc1ms">
      <TopBar data-id="element-1" data-mp="23vchsmqej08z" />
      <main data-id="element-2" data-mp="23vune9yyeqtk">
        <Hero data-id="element-3" data-mp="23w4ek0vqj40u" />
        <KeyNumbers data-id="element-4" data-mp="23ujmchww7x65" />
        <Problems data-id="element-5" data-mp="23v2td3l0915e" />
        <BrandReveal data-id="element-6" data-mp="23ti5txx3yih1" />
        <Volumes data-id="element-7" data-mp="3ikh7o8icgqyg" />
        <Bonuses data-id="element-8" data-mp="3iiweam7rne26" />
        <Pricing data-id="element-9" data-mp="3ijfvu1ti80fo" />
        <PlaybookSpotlight data-id="element-10" data-mp="3ihv2gfixenje" />
        <WhoItsFor data-id="element-11" data-mp="3mlavl1vse5rc" />
        <Guarantee data-id="element-12" data-mp="3mkrbpfmkt7ao" />
        <Faq data-id="element-13" data-mp="3mk84asujy1aw" />
        <FinalCta data-id="element-14" data-mp="3mjq27fl7ksv2" />
      </main>
      <Footer data-id="element-15" data-mp="3rc9dg5wfbbwp" />
    </div>;
}